// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fieldWrapper__EEj4A {
  display: flex;
  flex-direction: column;
}

.horizontalField__aMbsx {
  flex-direction: row;
  align-items: center;
  column-gap: 15px;
}

.helperText__OnMKm {
  color: var(--inputs-error-text-helper);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  margin-top: 5px;
  min-height: 12px;
}
@media (max-width: 850px) {
  .helperText__OnMKm {
    font-size: 8px;
    line-height: 8px;
    margin-top: 2px;
    min-height: 8px;
  }
}

.label__aneIy {
  margin-bottom: 7px;
  white-space: nowrap;
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}

.horizontalLabel__UO9fh {
  margin-bottom: 0;
}

.required__lLgjk:after {
  content: "*";
  font-size: 10px;
  line-height: 12px;
  color: var(--inputs-error-text-helper);
  margin-left: 4px;
}

.tabsWrapper__Iq1hM {
  display: grid;
  width: 100%;
  min-height: 35px;
  padding: 2px;
  background: var(--tabs-surface-default);
  border-radius: 3px;
}

.itemInput__kGl2X {
  display: none;
}

.itemBtn__t7NUD {
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  color: var(--tabs-text-default);
  text-align: center;
  background: var(--tabs-surface-default);
  text-transform: capitalize;
  padding: 9px 15px;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}
.itemBtn__t7NUD:not(.itemBtnChecked__g1oWZ):not(.itemBtnDisabled__h2B32):hover {
  background: var(--tabs-surface-hover);
  color: var(--tabs-text-hover);
}
@media (max-width: 850px) {
  .itemBtn__t7NUD {
    padding-left: 15px;
    padding-right: 15px;
  }
}

.itemBtnChecked__g1oWZ {
  font-weight: 500;
  color: var(--tabs-text-active);
  background-color: var(--tabs-surface-active);
}

.itemBtnDisabled__h2B32 {
  color: var(--tabs-text-disable);
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./../src/components/uikit/Tabs/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,sBAAA;AAzEF;;AA4EA;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,sCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAzEF;AA2EE;EATF;IAUI,cAAA;IACA,gBAAA;IACA,eAAA;IACA,eAAA;EAxEF;AACF;;AA2EA;EACE,kBAAA;EACA,mBAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAxEF;;AA2EA;EACE,gBAAA;AAxEF;;AA4EE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,gBAAA;AAzEJ;;AA6EA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,uCAAA;EACA,kBAAA;AA1EF;;AA6EA;EACE,aAAA;AA1EF;;AA6EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,kBAAA;EACA,uCAAA;EACA,0BAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AA1EF;AA4EE;EACE,qCAAA;EACA,6BAAA;AA1EJ;AA6EE;EAlBF;IAmBI,kBAAA;IACA,mBAAA;EA1EF;AACF;;AA6EA;EACE,gBAAA;EACA,8BAAA;EACA,4CAAA;AA1EF;;AA6EA;EACE,+BAAA;EACA,oBAAA;AA1EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.fieldWrapper {\n  display: flex;\n  flex-direction: column;\n}\n\n.horizontalField {\n  flex-direction: row;\n  align-items: center;\n  column-gap: 15px;\n}\n\n.helperText {\n  color: var(--inputs-error-text-helper);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n  margin-top: 5px;\n  min-height: 12px;\n\n  @media (max-width: 850px) {\n    font-size: 8px;\n    line-height: 8px;\n    margin-top: 2px;\n    min-height: 8px;\n  }\n}\n\n.label {\n  margin-bottom: 7px;\n  white-space: nowrap;\n  color: var(--title-inputs-sections-title);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n\n.horizontalLabel {\n  margin-bottom: 0;\n}\n\n.required {\n  &:after {\n    content: '*';\n    font-size: 10px;\n    line-height: 12px;\n    color: var(--inputs-error-text-helper);;\n    margin-left: 4px;\n  }\n}\n\n.tabsWrapper {\n  display: grid;\n  width: 100%;\n  min-height: 35px;\n  padding: 2px;\n  background: var(--tabs-surface-default);\n  border-radius: 3px;\n}\n\n.itemInput {\n  display: none;\n}\n\n.itemBtn {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--tabs-text-default);\n  text-align: center;\n  background: var(--tabs-surface-default);\n  text-transform: capitalize;\n  padding: 9px 15px;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n\n  &:not(.itemBtnChecked):not(.itemBtnDisabled):hover {\n    background: var(--tabs-surface-hover);\n    color: var(--tabs-text-hover);\n  }\n\n  @media (max-width: 850px) {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n}\n\n.itemBtnChecked {\n  font-weight: 500;\n  color: var(--tabs-text-active);\n  background-color: var(--tabs-surface-active);\n}\n\n.itemBtnDisabled {\n  color: var(--tabs-text-disable);\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fieldWrapper": `fieldWrapper__EEj4A`,
	"horizontalField": `horizontalField__aMbsx`,
	"helperText": `helperText__OnMKm`,
	"label": `label__aneIy`,
	"horizontalLabel": `horizontalLabel__UO9fh`,
	"required": `required__lLgjk`,
	"tabsWrapper": `tabsWrapper__Iq1hM`,
	"itemInput": `itemInput__kGl2X`,
	"itemBtn": `itemBtn__t7NUD`,
	"itemBtnChecked": `itemBtnChecked__g1oWZ`,
	"itemBtnDisabled": `itemBtnDisabled__h2B32`
};
module.exports = ___CSS_LOADER_EXPORT___;
